import { UntypedFormGroup } from "@angular/forms";
import { CompanyMasterData } from "./company-master-data";

interface ICompanyHandlerMasterData {
  handleCompanyMasterData(companyMasterData: CompanyMasterData): void;
}

export class CompanyHandlerMasterData implements ICompanyHandlerMasterData {
  constructor(private formCompanyRegistration: UntypedFormGroup) {}

  public handleCompanyMasterData(companyMasterData: CompanyMasterData): string[] {
    const companyHandlerMasterData: string[] = [];

    if (companyMasterData.getCorporateName() !== "") {
      this.formCompanyRegistration.patchValue({ corporateName: companyMasterData.getCorporateName() });
      companyHandlerMasterData.push("corporateName");
    }

    if (companyMasterData.getTradingName() !== "") {
      this.formCompanyRegistration.patchValue({ tradingName: companyMasterData.getTradingName() });
      companyHandlerMasterData.push("tradingName");
    }

    if (companyMasterData.getCompanyInfo().getAddress()[0].getStreet() !== "") {
      this.formCompanyRegistration.patchValue({ street: companyMasterData.getCompanyInfo().getAddress()[0].getStreet() });
      companyHandlerMasterData.push("street");
    }

    if (companyMasterData.getCompanyInfo().getAddress()[0].getNumber() !== "") {
      this.formCompanyRegistration.patchValue({ number: companyMasterData.getCompanyInfo().getAddress()[0].getNumber() });
      companyHandlerMasterData.push("number");
    }

    if (companyMasterData.getCompanyInfo().getAddress()[0].getComplement() !== "") {
      this.formCompanyRegistration.patchValue({ complement: companyMasterData.getCompanyInfo().getAddress()[0].getComplement() });
      companyHandlerMasterData.push("complement");
    }

    if (companyMasterData.getCompanyInfo().getAddress()[0].getDistrict() !== "") {
      this.formCompanyRegistration.patchValue({ district: companyMasterData.getCompanyInfo().getAddress()[0].getDistrict() });
      companyHandlerMasterData.push("district");
    }

    if (companyMasterData.getCompanyInfo().getAddress()[0].getCity() !== "") {
      this.formCompanyRegistration.patchValue({ city: companyMasterData.getCompanyInfo().getAddress()[0].getCity() });
      companyHandlerMasterData.push("city");
    }

    if (companyMasterData.getCompanyInfo().getAddress()[0].getState() !== "") {
      this.formCompanyRegistration.patchValue({ region: companyMasterData.getCompanyInfo().getAddress()[0].getState() });
      companyHandlerMasterData.push("region");
    }

    if (
      companyMasterData
        .getCompanyInfo()
        .getAddress()[0]
        .getZipCode()
        .replace(/[^\d]+/g, "") !== ""
    ) {
      this.formCompanyRegistration.patchValue({ zipCode: companyMasterData.getCompanyInfo().getAddress()[0].getZipCode() });
      companyHandlerMasterData.push("zipCode");
    }
    return companyHandlerMasterData;
  }
}
